import { IS_GALLERY_IMAGE_UPLOAD, IS_PROD_FROM_LISTING, IS_SLIDER, SET_NOTIFICATION_COUNT } from "./action";

const initialState = {
    counts: {},
    slider: false,
    isImageUpload: false,
    isProdFromListing: false,
}

export default (state = initialState, action) => {
    const payload = action?.payload;

    switch (action.type) {
        case SET_NOTIFICATION_COUNT: {
            return {
                ...state, counts: payload
            }
        }
        case IS_SLIDER: {
            return {
                ...state, slider: payload
            }
        }
        case IS_GALLERY_IMAGE_UPLOAD: {
            return {
                ...state, isImageUpload: payload
            }
        }
        case IS_PROD_FROM_LISTING: {
            return {
                ...state, isProdFromListing: payload
            }
        }
        default:
            return state;
    }
}